import { createContext, useContext, useEffect, useState } from "react";
import { T } from "./content";

const LangCtx = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("vl-lang") || "id");
  useEffect(() => {
    localStorage.setItem("vl-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  return <LangCtx.Provider value={{ lang, setLang, t: T[lang] }}>{children}</LangCtx.Provider>;
};

export const useLang = () => useContext(LangCtx);
